import { createProvider } from '@nvision/services/data-provider';

import type { SupplierDiversityFilters } from '../../models';
import * as api from './api';
import { normalizeSupplierDiversities, normalizeSupplierDiversityFilters } from './normalize';

export const fetchSupplierDiversities = createProvider(
  (filters: Partial<SupplierDiversityFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchSupplierDiversities(normalizeSupplierDiversityFilters(filters), { signal }),
).andThen((res) => normalizeSupplierDiversities(res));
